document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".category-carousel.swiper");

  if (!slider || typeof Swiper === "undefined") return;

  new Swiper(slider, {

    loop: true,

    speed: 700,

    spaceBetween: 20,

    slidesPerView: 1,

    navigation: {
      nextEl: ".category-next",
      prevEl: ".category-prev",
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

    breakpoints: {

      320: {
        slidesPerView: 2,
      },

      576: {
        slidesPerView: 2,
      },

      768: {
        slidesPerView: 2,
      },

      992: {
        slidesPerView: 3,
      },

      1200: {
        slidesPerView: 4,
      }

    }

  });

});